export const TRADE_TYPES_ORDER = {
  buy: 1,
  sell: 2,
  short: 3,
  cover: 4,
}

const HEADER_PREFIX = ["Trade Type", "Identifier", "MIC"]

export const TRADE_EXPORT_BLOOMBERG_TICKER_HEADER = "Bloomberg Ticker"

const HEADER_AFTER_MIC = ["Country", "Asset Class", "Currency", "Industry"]

const POSITION_METRICS_ABSOLUTE_VIEW = [
  "Original Position Size",
  "Rebalanced Position Size",
  "Position $ Change",
  "Original Equity %",
  "Rebalanced Equity %",
  "Equity % Change",
]

const POSITION_METRICS_ACTIVE_VIEW = [
  "Original Active Size",
  "Rebalanced Active Size",
  "Position $ Change",
  "Original Active Equity %",
  "Rebalanced Active Equity %",
  "Equity % Change",
]

export function getTradeExportCsvHeaders(isActiveView, { bloombergTickerColumn = false } = {}) {
  const metrics = isActiveView ? POSITION_METRICS_ACTIVE_VIEW : POSITION_METRICS_ABSOLUTE_VIEW

  return [
    ...HEADER_PREFIX,
    ...(bloombergTickerColumn ? [TRADE_EXPORT_BLOOMBERG_TICKER_HEADER] : []),
    ...HEADER_AFTER_MIC,
    ...metrics,
  ]
}
